var _rect, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvestorPotectionImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 582,
    height: 500,
    viewBox: "0 0 582 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 582,
    height: 500,
    rx: 24,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 582,
    height: 500,
    rx: 24,
    fill: "url(#paint0_linear_172348_12243)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_172348_12243",
    x1: 606.323,
    y1: 0.0000519085,
    x2: -94.498,
    y2: 507.746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#335CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.322435,
    stopColor: "#182F8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.641117,
    stopColor: "#335CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.954845,
    stopColor: "#1F3BAD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvestorPotectionImg);
export default __webpack_public_path__ + "static/media/investor_potection_img.8789a551a7b7f7586a62c5a626705ff6.svg";
export { ForwardRef as ReactComponent };